import { ChangeEvent, FormEvent, useContext, useState } from "react"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Card } from "primereact/card"
import commonStyles from "../common.module.css"
import { useNavigate, useParams } from "react-router-dom"
import { useAuthSetPassword } from "../../api/queries/useAuthSetPassword"
import Logo from "../common/Logo"
import styles from "./styles.module.css"
import globalToastContext from "../../context/globalToast"

type Params = "token"

export default function SetPassword() {
  const { token } = useParams<Params>()
  const navigate = useNavigate()
  const setPassword = useAuthSetPassword()
  const { ref } = useContext(globalToastContext)

  const [newPassword, setNewPassword] = useState<string>("")
  const [newPasswordConfirm, setNewPasswordConfirm] = useState<string>("")
  const handleNewPasswordChange = (event: ChangeEvent<HTMLInputElement>) =>
    setNewPassword(event.target.value)
  const handleNewPasswordConfirmChange = (event: ChangeEvent<HTMLInputElement>) =>
    setNewPasswordConfirm(event.target.value)

  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState<boolean>(false)
  const [isNewPasswordConfirmVisible, setIsNewPasswordConfirmVisible] = useState<boolean>(false)

  const [errors, setErrors] = useState<string[]>([])

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (newPassword !== newPasswordConfirm) {
      return setErrors(["Hesla se neshodují"])
    }

    if (token) {
      let res = await setPassword.mutateAsync({ newPassword, token })

      if (res.errors.length > 0) {
        return setErrors(res.errors.map((err: any) => err.message))
      }

      ref?.current?.show({ severity: "success", summary: "Heslo změněno." })

      navigate("/login")
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card title={""} className={styles.card}>
        <Logo />

        <h2>Resetovat heslo</h2>

        <div className={"p-fluid"}>
          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Nové heslo:</label>
            <div className={"p-inputgroup"}>
              <InputText type={isNewPasswordVisible ? "text" : "password"}
                required={true} value={newPassword} onChange={handleNewPasswordChange}
                minLength={6} />
              <Button type={"button"} icon={`pi pi-${isNewPasswordVisible ? "eye-slash" : "eye"}`}
                className={"p-button-secondary"}
                onClick={() => setIsNewPasswordVisible(!isNewPasswordVisible)} />
            </div>
            <small className={`${commonStyles.fieldHelp} text-color`}>Minimální délka hesla je 6 znaků.</small>
          </div>
        </div>

        <div className={"p-fluid"}>
          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Nové heslo potvrzení:</label>
            <div className={"p-inputgroup"}>
              <InputText type={isNewPasswordConfirmVisible ? "text" : "password"}
                required={true} value={newPasswordConfirm} onChange={handleNewPasswordConfirmChange} />
              <Button type={"button"} icon={`pi pi-${isNewPasswordConfirmVisible ? "eye-slash" : "eye"}`}
                className={"p-button-secondary"}
                onClick={() => setIsNewPasswordConfirmVisible(!isNewPasswordConfirmVisible)} />
            </div>
          </div>
        </div>

        {errors.length > 0 && (
          <div className={"mb-3"}>
            {errors.map((error) => (
              <div key={error} className={"text-pink-500 flex align-items-center"}>
                <i className={"pi pi-exclamation-triangle mr-2 mt-1"} />
                {error}
              </div>
            ))}
          </div>
        )}

        <div className={"text-center"}>
          <Button label={"Odeslat"} disabled={!newPassword || setPassword.isLoading}
            icon={"pi pi-send"} />
        </div>
      </Card>
    </form>
  )
}
